import { Component, inject, Input } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { TranslateService } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-auth-top-bar',
  templateUrl: './auth-top-bar.component.html',
  styleUrl: './auth-top-bar.component.scss',
  standalone  : true,
  imports: [SharedModule, RouterModule],
})
export class AuthTopBarComponent {
  private readonly translate: TranslateService = inject(TranslateService);

  @Input() onWhiteBg : boolean

  changeLanguage(language: 'sw' | 'en'): void {
    this.translate.use(language);
    localStorage.setItem('lang', language);
  }
}
